export default function PrivacyPolicy() {
  return (
    <div className="min-h-screen bg-gray-50 py-10 px-4 sm:px-6 lg:px-8">
      <div className="max-w-4xl mx-auto bg-white shadow-sm rounded-lg p-8 sm:p-12">
        <h1 className="text-4xl font-bold text-gray-800 mb-6">Privacy Policy</h1>
        
        <p className="mb-4 text-gray-700">
          <strong>ParkEZY</strong> is developed by <strong>GJ Global IT Ventures Pvt. Ltd.</strong> to provide a digital and efficient parking management experience. The app helps users mark vehicle entries and exits, make parking payments, scan QR codes for quick access, and monitor available parking slots.
        </p>

        <p className="mb-8 text-gray-700">
          This Privacy Policy explains how we collect, use, and protect the personal and operational information of users who use the ParkEZY application.
        </p>

        <h2 className="text-2xl font-semibold text-gray-800 mt-8 mb-4">Information We Collect</h2>
        <p className="mb-4 text-gray-700">
          To provide our parking management services effectively, we may collect and store the following types of information:
        </p>
        <ul className="list-disc list-inside mb-8 space-y-2 text-gray-700">
          <li>
            <strong>Personal Information:</strong> Such as name, email address, and mobile number, used to create and manage user accounts.
          </li>
          <li>
            <strong>Vehicle Information:</strong> Such as vehicle number, type, and parking duration for tracking entries and exits.
          </li>
          <li>
            <strong>Payment Information:</strong> Transaction details (amount, date, time, payment status) collected during online payments. Note: We do not store or access your card or UPI credentials. Payments are securely handled by our integrated payment gateway.
          </li>
          <li>
            <strong>Device and Usage Data:</strong> May include app version, device type, and activity logs to improve app performance and user experience.
          </li>
        </ul>

        <h2 className="text-2xl font-semibold text-gray-800 mt-8 mb-4">How We Use the Information</h2>
        <p className="mb-4 text-gray-700">
          The collected data is used solely for providing and improving our parking management services, including:
        </p>
        <ul className="list-disc list-inside mb-8 space-y-2 text-gray-700">
          <li>To manage vehicle entry and exit records accurately.</li>
          <li>To process parking payments and generate digital receipts.</li>
          <li>To display available parking slots and occupancy analytics.</li>
          <li>To ensure security and prevent misuse of the system.</li>
        </ul>

        <h2 className="text-2xl font-semibold text-gray-800 mt-8 mb-4">Data Storage and Security</h2>
        <p className="mb-8 text-gray-700">
          All user and parking data is securely stored in our protected systems and can be accessed only by authorized parking administrators and staff. We use reasonable technical and organizational measures to prevent unauthorized access, loss, or misuse of your information.
        </p>

        <h2 className="text-2xl font-semibold text-gray-800 mt-8 mb-4">No Third-Party Sharing</h2>
        <p className="mb-8 text-gray-700">
          We do not sell, rent, or share any personal data with third parties for marketing purposes. However, we may share data with trusted service providers (such as payment gateways) only for processing legitimate transactions and service-related operations.
        </p>

        <h2 className="text-2xl font-semibold text-gray-800 mt-8 mb-4">Data Retention</h2>
        <p className="mb-8 text-gray-700">
          User and vehicle data are retained only for as long as necessary to provide services or as required by the organization or applicable law. Once the account is deleted or no longer in use, related data is removed from our systems within a reasonable timeframe.
        </p>

        <h2 className="text-2xl font-semibold text-gray-800 mt-8 mb-4">Children's Privacy</h2>
        <p className="mb-8 text-gray-700">
          ParkEZY is intended for adult users managing or accessing parking facilities. We do not knowingly collect personal data from individuals under the age of 18. If such data is found, it will be deleted promptly.
        </p>

        <h2 className="text-2xl font-semibold text-gray-800 mt-8 mb-4">Changes to This Privacy Policy</h2>
        <p className="mb-4 text-gray-700">
          We may update this Privacy Policy from time to time to reflect changes in our practices or for other operational, legal, or regulatory reasons. Any updates will be posted on this page, and the updated date will be revised accordingly.
        </p>
        <p className="mb-8 text-gray-700">
          This policy is effective as of <strong>2025-10-01</strong>.
        </p>

        <h2 className="text-2xl font-semibold text-gray-800 mt-8 mb-4">Contact Us</h2>
        <p className="mb-2 text-gray-700">
          If you have any questions, concerns, or requests related to this Privacy Policy, please contact us at:
        </p>
        <p className="text-gray-700">
          <a href="mailto:apps@gjglobalsoft.com" className="text-blue-600 hover:text-blue-700 underline">
            apps@gjglobalsoft.com
          </a>
        </p>
      </div>
    </div>
  );
}